module.exports = __webpack_public_path__ + "img/ep-body.802f25f2.jpg";